export default "__VITE_ASSET__DdyexDkf__";